import React from 'react';
import PropTypes from 'prop-types';
import { TrackOutOfStock } from '@thd-olt-component-react/email-signup';
import { useConfigService } from '@thd-nucleus/experience-context';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import { FEATURE_SWITCHES } from '../../constants';
import { MajorApplianceOutOfStock } from './MajorApplianceOutOfStock';

const NotifyMe = (
  {
    isMajorAppliance = false,
    showCheckAvailability,
    setShowCheckAvailability,
    itemId = null,
    store = null,
    shipping = null,
    skipEmailOptIn = false,
    zipCode = null
  }
) => {
  const enableSms = useConfigService('enableSmsForOOSnotifications') || false;
  const enableOOSRecommendations = useConfigService(FEATURE_SWITCHES.ENABLE_OOS_RECOMMENDATIONS) || false;

  const theme = useTheme(NotifyMe);
  const { showTrackOutOfStock } = theme.props;

  const handleOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowCheckAvailability(!showCheckAvailability);
  };

  const availabilityButton = (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      component="span"
      onClick={handleOnClick}
    >Change Delivery Zip Code
    </Link>
  );

  if (isMajorAppliance && enableOOSRecommendations) {
    return (
      <MajorApplianceOutOfStock itemId={itemId} zipCode={zipCode} onCheckAnotherZip={handleOnClick} />
    );
  }

  if (isMajorAppliance) {
    return (
      <div
        className="sui-max-w-md"
        data-testid="fulfillment__unavailable"
        data-component="FulfillmentNotifyMe"
      >
        <Typography
          variant="h3"
          weight="bold"
          height="tight"
          data-automation-id="fulfillment__out-of-stock"
        >
          Out of Stock
        </Typography>
        <Typography variant="body-base">This product is currently out of stock.</Typography>
        <span>{availabilityButton}</span>
      </div>
    );
  }

  const noStockAvailable = !shipping.enabled && !store.enabled && shipping.outOfStock;

  return (
    <div
      className="sui-max-w-md"
      data-testid="fulfillment__unavailable"
      data-component="FulfillmentNotifyMe"
    >
      <Typography variant="h3" data-automation-id="fulfillment__out-of-stock">
        Out of Stock
      </Typography>
      {showTrackOutOfStock && !skipEmailOptIn && (shipping?.showNotify || noStockAvailable) ? (
        <div>
          <TrackOutOfStock itemId={itemId} enableSms={enableSms} />
        </div>
      ) : (
        <div className="sui-pt-2">
          <Typography variant="body-base">This item is currently unavailable.</Typography>
        </div>
      )}
    </div>
  );
};

NotifyMe.propTypes = {
  isMajorAppliance: PropTypes.bool,
  showCheckAvailability: PropTypes.bool.isRequired,
  setShowCheckAvailability: PropTypes.func.isRequired,
  itemId: PropTypes.string,
  store: PropTypes.shape({
    method: PropTypes.string,
    unavailable: PropTypes.bool
  }),
  shipping: PropTypes.shape({
    method: PropTypes.string,
    unavailable: PropTypes.bool
  }),
  skipEmailOptIn: PropTypes.bool,
  zipCode: PropTypes.string
};

NotifyMe.themeProps = {
  showTrackOutOfStock: PropTypes.bool
};

NotifyMe.defaultThemeProps = {
  showTrackOutOfStock: true
};

NotifyMe.displayName = 'NotifyMe';

export { NotifyMe };
